import PagesCalendar from './PagesCalendar';
import PagesRoomsAndRates from './PagesRoomsAndRates';
import PagesAddOns from './PagesAddOns';
import PagesCart from './PagesCart';
import PagesGuestPayment from './PagesGuestPayment';
import PagesReview from './PagesReview';
import PagesConfirmation from './PagesConfirmation';
import PagesFindRes from './PagesFindRes';
import PagesModifyRes from './PagesModifyRes';
import PagesTeaser from './PagesTeaser';
import PagesSideWide from './PagesSideWide';
import PagesProduct from './PagesProduct';
import PagesProductIcons from './PagesProductIcons';
import PagesRetailProducts from './PagesRetailProducts';
import PagesCustomContent from './PagesCustomContent';

export {
    PagesCalendar,
    PagesRoomsAndRates,
    PagesAddOns,
    PagesCart,
    PagesGuestPayment,
    PagesReview,
    PagesConfirmation,
    PagesFindRes,
    PagesModifyRes,
    PagesTeaser,
    PagesSideWide,
    PagesProduct,
    PagesProductIcons,
    PagesRetailProducts,
    PagesCustomContent
};



// WEBPACK FOOTER //
// ./src/components/pages/pages/index.js